// Initialize current language
let currentLang = localStorage.getItem('site-language') || 'ja';

// Detect browser language on first visit
if (!localStorage.getItem('site-language')) {
  const browserLang = navigator.language || navigator.languages[0];
  currentLang = browserLang.toLowerCase().includes('ja') ? 'ja' : 'en';
  localStorage.setItem('site-language', currentLang);
}

// Set html lang attribute
document.documentElement.lang = currentLang;

// Apply translations to the page
function applyTranslations() {
  const elements = document.querySelectorAll('[data-i18n]');
  elements.forEach(el => {
    const key = el.getAttribute('data-i18n');
    const translatedText = window.t(key, currentLang);
    
    // Always update aria-label if it exists
    if (el.hasAttribute('aria-label')) {
      el.setAttribute('aria-label', translatedText);
    }
    
    // Update content based on element type
    if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
      el.placeholder = translatedText;
    } else if (!el.hasAttribute('aria-label')) {
      // Only update innerHTML if not an aria-label-only element
      el.innerHTML = translatedText;
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  // Apply translations when page loads
  applyTranslations();


  // Scroll Animation
  const animatedElements = document.querySelectorAll('.fade-in-on-scroll');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.05,
  });

  animatedElements.forEach(element => {
    observer.observe(element);
  });

  // Ajax Cart Functionality
  const cartForms = document.querySelectorAll('form[action="/cart/add"]');
  
  cartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const formData = new FormData(form);
      const productTitle = form.closest('.product-card, .product-showcase__product, .product-detail')?.querySelector('h1, h2, h3, .product-title')?.textContent || '商品';
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        if (response.ok) {
          const data = await response.json();
          
          // Fetch updated cart to get accurate item count
          try {
            const cartResponse = await fetch('/cart.js');
            if (cartResponse.ok) {
              const cartData = await cartResponse.json();
              
              // Update all cart count badges in header (desktop and mobile)
              const cartIconWrappers = document.querySelectorAll('.site-header__cart-icon-wrapper');
              cartIconWrappers.forEach(wrapper => {
                let cartCountElement = wrapper.querySelector('.site-header__cart-count');
                
                // Create badge element if it doesn't exist
                if (!cartCountElement && cartData.item_count > 0) {
                  cartCountElement = document.createElement('span');
                  cartCountElement.className = 'site-header__cart-count';
                  wrapper.appendChild(cartCountElement);
                }
                
                if (cartCountElement) {
                  cartCountElement.textContent = cartData.item_count;
                  if (cartData.item_count > 0) {
                    cartCountElement.style.display = 'flex';
                  } else {
                    cartCountElement.style.display = 'none';
                  }
                }
              });
            }
          } catch (cartError) {
            console.error('Error fetching cart:', cartError);
            // Fallback: try to use data.item_count if available
            const cartIconWrappers = document.querySelectorAll('.site-header__cart-icon-wrapper');
            if (data.item_count !== undefined) {
              cartIconWrappers.forEach(wrapper => {
                let cartCountElement = wrapper.querySelector('.site-header__cart-count');
                
                // Create badge element if it doesn't exist
                if (!cartCountElement && data.item_count > 0) {
                  cartCountElement = document.createElement('span');
                  cartCountElement.className = 'site-header__cart-count';
                  wrapper.appendChild(cartCountElement);
                }
                
                if (cartCountElement) {
                  cartCountElement.textContent = data.item_count;
                  if (data.item_count > 0) {
                    cartCountElement.style.display = 'flex';
                  }
                }
              });
            }
          }
          
          // Show notification popup
          showCartNotification(data, productTitle);
        } else {
          console.error('Cart add failed:', response.statusText);
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    });
  });

  // Cart item removal functionality
  const removeButtons = document.querySelectorAll('.cart-item__remove, [data-cart-item-remove]');
  removeButtons.forEach(button => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      
      const lineItemId = button.dataset.lineItemId || button.closest('[data-line-item-id]')?.dataset.lineItemId;
      if (!lineItemId) return;
      
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: lineItemId,
            quantity: 0
          })
        });
        
        if (response.ok) {
          const data = await response.json();
          
          // Fetch updated cart to get accurate item count
          try {
            const cartResponse = await fetch('/cart.js');
            if (cartResponse.ok) {
              const cartData = await cartResponse.json();
              
              // Update all cart count badges in header (desktop and mobile)
              const cartIconWrappers = document.querySelectorAll('.site-header__cart-icon-wrapper');
              cartIconWrappers.forEach(wrapper => {
                let cartCountElement = wrapper.querySelector('.site-header__cart-count');
                
                // Create badge element if it doesn't exist and item count > 0
                if (!cartCountElement && cartData.item_count > 0) {
                  cartCountElement = document.createElement('span');
                  cartCountElement.className = 'site-header__cart-count';
                  wrapper.appendChild(cartCountElement);
                }
                
                if (cartCountElement) {
                  cartCountElement.textContent = cartData.item_count;
                  if (cartData.item_count > 0) {
                    cartCountElement.style.display = 'flex';
                  } else {
                    cartCountElement.style.display = 'none';
                  }
                }
              });
            }
          } catch (cartError) {
            console.error('Error fetching cart:', cartError);
            // Fallback: try to use data.item_count if available
            const cartIconWrappers = document.querySelectorAll('.site-header__cart-icon-wrapper');
            if (data.item_count !== undefined) {
              cartIconWrappers.forEach(wrapper => {
                let cartCountElement = wrapper.querySelector('.site-header__cart-count');
                
                // Create badge element if it doesn't exist and item count > 0
                if (!cartCountElement && data.item_count > 0) {
                  cartCountElement = document.createElement('span');
                  cartCountElement.className = 'site-header__cart-count';
                  wrapper.appendChild(cartCountElement);
                }
                
                if (cartCountElement) {
                  cartCountElement.textContent = data.item_count;
                  if (data.item_count === 0) {
                    cartCountElement.style.display = 'none';
                  } else {
                    cartCountElement.style.display = 'flex';
                  }
                }
              });
            }
          }
          
          // Remove item from cart page or reload
          if (window.location.pathname === '/cart') {
            location.reload();
          }
        }
      } catch (error) {
        console.error('Error removing cart item:', error);
      }
    });
  });
});

// Price formatting function
// Shopify returns prices in cents, so we need to divide by 100
function formatPrice(priceInCents) {
  if (!priceInCents) return '';
  const price = priceInCents / 100;
  // Format with comma separators and add 円
  return new Intl.NumberFormat('ja-JP').format(price) + '円';
}

// Cart notification popup function
function showCartNotification(cartData, productTitle) {
  const notification = document.getElementById('cart-notification');
  if (!notification) return;
  
  // Update notification content
  const productContainer = notification.querySelector('#cart-notification-product');
  if (productContainer) {
    productContainer.innerHTML = `
      <img src="${cartData.image || '/assets/product-1.svg'}" 
           alt="${productTitle}" 
           class="cart-notification__product-image">
      <div class="cart-notification__product-info">
        <h3 class="cart-notification__product-title">${productTitle}</h3>
      </div>
    `;
  }
  
  // Show notification
  notification.classList.add('is-visible');
  
  // Auto hide after 5 seconds
  setTimeout(() => {
    notification.classList.remove('is-visible');
  }, 5000);
}